document.querySelectorAll('.footer-form').forEach((formEL) => {
    formEL.addEventListener('submit', (event) => {
        event.preventDefault();

        formEL.querySelector('button').style.pointerEvents = 'none';

        const email = formEL.querySelector('#email')?.value;
        const checked = formEL.querySelector('#terms')?.checked;

        fetch('https://the-crescent-form-handler.vercel.app/api/footer-submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                email,
                checked,
                secret: "QlXdNXh3hHFIcexLBBq92fY-c0OPrNKmOhqGHsvn1f",
            })
        }).then((response) => {
            return response.json();
        }).then((json) => {
            formEL.querySelector('button').style.pointerEvents = 'all';
            console.log(json);
            formEL.querySelector('.response').innerHTML = json.message;
        });
    });
});

document.querySelectorAll('form.wpcf7-form').forEach((registerFormEl) => {
    registerFormEl.addEventListener('submit', (event) => {
        event.preventDefault();


        const first_name = registerFormEl.querySelector('input#first-name')?.value;
        const last_name = registerFormEl.querySelector('input#last-name')?.value;
        const phone_number = registerFormEl.querySelector('input#phone-number')?.value;
        const email = registerFormEl.querySelector('input#email[aria-invalid="false"]')?.value;
        const postcode = registerFormEl.querySelector('input#postcode')?.value;
        let buyer_information = registerFormEl.querySelector('input[name="buyer-info"]:checked')?.value;
        const message = registerFormEl.querySelector('textarea#message')?.value;
        const checked = registerFormEl.querySelector('input[name="your-consent"]')?.checked;
        const newsletter = registerFormEl.querySelector('input[name="updates"]')?.checked;

        switch (buyer_information) {
            case 'I am a cash buyer':
                buyer_information = 'Cash Buyer';
                break;

            case 'I am selling my current house (On the market)':
                buyer_information = 'House to sell OTM';
                break;

            case 'I will be selling my current house (Not on the market)':
                buyer_information = 'House to sell NOTM';
                break;

            case 'My house is sold subject to contract':
                buyer_information = 'SSTS';
                break;

            case 'Prefer not to say':
                buyer_information = 'Prefer not to say';
        }

        if (first_name && last_name && email && checked) {
            registerFormEl.querySelector('input.wpcf7-submit').style.pointerEvents = 'none';

            fetch('https://the-crescent-form-handler.vercel.app/api/register-submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    email,
                    first_name,
                    last_name,
                    phone_number,
                    postcode,
                    buyer_information,
                    message,
                    checked,
                    newsletter,
                    secret: "QlXdNXh3hHFIcexLBBq92fY-c0OPrNKmOhqGHsvn1f",
                })
            }).then((response) => {
                return response.json();
            }).then((json) => {
                if (registerFormEl.id === 'login-form') {
                    document.cookie = "custom_logged_in=true; path=/; max-age=" + (60 * 60 * 24 * 90); // Expires in 90 days
                    window.location.href = "/";
                }
            }).then((json) => {
                registerFormEl.querySelector('input.wpcf7-submit').style.pointerEvents = 'all';
                console.log(json);
            });
        }
    });
});